// Deterministic model-key → palette-index hash.
//
// Used by the `Related ▾` dropdown's count badges so every chip targeting
// the same model lands on the same background colour across the app
// (`crm.lead` always lights up the same shade; `crm.opportunity` another).
//
// The output is a stable index into 0..PALETTE_SIZE-1; the actual colours
// are theme-token-driven (`--related-badge-bg-0` … `--related-badge-bg-N`)
// so they stay in sync with light/dark/brand variants.

const PALETTE_SIZE = 11;

export function colorForModel(modelKey: string): number {
    // Tiny FNV-1a 32-bit hash — collision-tolerant for an 11-slot bucket,
    // deterministic across runs, no crypto dependency.
    let hash = 0x811c9dc5;
    for (let i = 0; i < modelKey.length; i++) {
        hash ^= modelKey.charCodeAt(i);
        hash = Math.imul(hash, 0x01000193);
    }
    // Math.imul can yield negative ints; mask before modulo.
    return (hash >>> 0) % PALETTE_SIZE;
}
